import type { Key } from 'react';

const HEX_COLOR_REGEX = /^#[0-9a-fA-F]{3,8}$/;
const RGB_COLOR_REGEX = /^rgba?\(\d{1,3}(,\d{1,3}){2}(,\d?\.?\d+)?\)$/;
const NAMED_COLOR_REGEX = /^[a-zA-Z]+$/;

/**
 * Sanitizes a row key to be safe for use in a CSS class selector.
 * Replaces any non-alphanumeric/hyphen/underscore characters with underscores.
 */
export const sanitizeCssClassName = (key: Key): string => {
  const raw = String(key);

  if (!raw.length) return '_empty';

  return raw.replaceAll(/[^a-zA-Z0-9_-]/g, '_');
};

/**
 * Validates that a color string is a safe CSS color value.
 * Only allows hex (#fff, #ffffff, #ffffffff), rgb/rgba, or named colors.
 * Returns undefined if the value is unsafe.
 */
export const sanitizeColor = (color?: string): string | undefined => {
  if (!color) return undefined;

  const trimmed = color.trim();
  const normalized = trimmed.replaceAll(/\s/g, '');

  const isValid =
    HEX_COLOR_REGEX.test(normalized) ||
    RGB_COLOR_REGEX.test(normalized) ||
    NAMED_COLOR_REGEX.test(normalized);

  return isValid ? trimmed : undefined;
};
